import React, { useMemo } from "react";
import DatePicker from "react-date-picker";
import { Value } from "react-date-picker/dist/cjs/shared/types";
import "react-calendar/dist/Calendar.css";
import moment from "moment";

export interface IDatePickerProps {
  name: string;
  label?: string;
  onChange: any;
  values?: any | undefined;
  errors?: any;
  touches?: any;
  onBlur?: any;
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
  placeholder?: string;
  hidden?: boolean;
  minDate?: any;
  maxDate?: any;
  format?: string;
}

export default function CustomDatePicker(props: IDatePickerProps) {
  const isInvalid = useMemo(() => {
    return props?.touches?.[props?.name] && props?.errors?.[props?.name];
  }, [props?.touches, props?.errors, props?.name]);

  return (
    <div className="flex flex-col justify-start items-start gap-2">
      <label
        htmlFor={props.name}
        className={`text-[11px] font-bold text-black ${
          props?.hidden && "hidden"
        }`}
      >
        {props.label}
      </label>

      <div className={props?.className || "w-full"}>
        <input
          name={props?.name}
          onChange={props?.onChange}
          value={props?.values[props?.name]}
          disabled={props.disabled}
          autoFocus={props?.autoFocus}
          onBlur={props?.onBlur}
          type="date"
          className="w-full border border-[#1718175C] rounded-md px-2 h-[34px] "
          max={props?.maxDate}
          min={props?.minDate}
        />
      </div>

      {isInvalid ? (
        <p className="text-red-500 font-[600] text-[10px]">
          {props?.errors?.[props?.name]}
        </p>
      ) : null}
    </div>
  );
}
